export const TurnoverStorageKey = 'turnover';
